import React, { useState, useRef } from 'react';
import { ChevronLeft, CreditCard, Camera, CheckCircle, AlertCircle, Building2, MapPin, Loader2 } from 'lucide-react';

const BANKS = [
  { id: 'icbc', name: '工商银行', color: 'from-red-500 to-red-600' },
  { id: 'ccb', name: '建设银行', color: 'from-blue-500 to-blue-600' },
  { id: 'abc', name: '农业银行', color: 'from-green-500 to-green-600' },
  { id: 'boc', name: '中国银行', color: 'from-red-600 to-red-700' },
  { id: 'cmb', name: '招商银行', color: 'from-red-400 to-red-500' },
  { id: 'bocom', name: '交通银行', color: 'from-blue-600 to-blue-700' },
  { id: 'spdb', name: '浦发银行', color: 'from-blue-400 to-blue-500' },
  { id: 'citic', name: '中信银行', color: 'from-red-500 to-red-600' },
  { id: 'ceb', name: '光大银行', color: 'from-orange-500 to-orange-600' },
  { id: 'cmbc', name: '民生银行', color: 'from-blue-500 to-blue-600' },
  { id: 'pingan', name: '平安银行', color: 'from-orange-400 to-orange-500' },
  { id: 'hxb', name: '华夏银行', color: 'from-red-500 to-red-600' },
];

const BRANCHES = {
  'icbc': ['工商银行北京分行', '工商银行上海分行', '工商银行广州分行', '工商银行深圳分行', '工商银行杭州分行', '工商银行南京分行', '工商银行马鞍山分行'],
  'ccb': ['建设银行北京分行', '建设银行上海分行', '建设银行广州分行', '建设银行深圳分行', '建设银行杭州分行', '建设银行南京分行', '建设银行马鞍山分行'],
  'abc': ['农业银行北京分行', '农业银行上海分行', '农业银行广州分行', '农业银行深圳分行', '农业银行杭州分行', '农业银行南京分行', '农业银行马鞍山分行'],
  'boc': ['中国银行北京分行', '中国银行上海分行', '中国银行广州分行', '中国银行深圳分行', '中国银行杭州分行', '中国银行南京分行', '中国银行马鞍山分行'],
  'cmb': ['招商银行北京分行', '招商银行上海分行', '招商银行广州分行', '招商银行深圳分行', '招商银行杭州分行', '招商银行南京分行', '招商银行马鞍山分行'],
  'bocom': ['交通银行北京分行', '交通银行上海分行', '交通银行广州分行', '交通银行深圳分行', '交通银行杭州分行', '交通银行南京分行', '交通银行马鞍山分行'],
  'spdb': ['浦发银行北京分行', '浦发银行上海分行', '浦发银行广州分行', '浦发银行深圳分行', '浦发银行杭州分行', '浦发银行南京分行', '浦发银行马鞍山分行'],
  'citic': ['中信银行北京分行', '中信银行上海分行', '中信银行广州分行', '中信银行深圳分行', '中信银行杭州分行', '中信银行南京分行', '中信银行马鞍山分行'],
  'ceb': ['光大银行北京分行', '光大银行上海分行', '光大银行广州分行', '光大银行深圳分行', '光大银行杭州分行', '光大银行南京分行', '光大银行马鞍山分行'],
  'cmbc': ['民生银行北京分行', '民生银行上海分行', '民生银行广州分行', '民生银行深圳分行', '民生银行杭州分行', '民生银行南京分行', '民生银行马鞍山分行'],
  'pingan': ['平安银行北京分行', '平安银行上海分行', '平安银行广州分行', '平安银行深圳分行', '平安银行杭州分行', '平安银行南京分行', '平安银行马鞍山分行'],
  'hxb': ['华夏银行北京分行', '华夏银行上海分行', '华夏银行广州分行', '华夏银行深圳分行', '华夏银行杭州分行', '华夏银行南京分行', '华夏银行马鞍山分行'],
};

export default function BankCardFormPage({ editingCard, onBack, onSave }) {
  const [step, setStep] = useState(1);
  const [cardImage, setCardImage] = useState(null);
  const [cardNumber, setCardNumber] = useState(editingCard?.cardNumber || '');
  const [selectedBank, setSelectedBank] = useState(
    BANKS.find(b => b.name === editingCard?.bankName)?.id || ''
  );
  const [selectedBranch, setSelectedBranch] = useState(editingCard?.branch || '');
  const [phone, setPhone] = useState(editingCard?.phone || '');
  const [recognizing, setRecognizing] = useState(false);
  const [showBankPicker, setShowBankPicker] = useState(false);
  const [showBranchPicker, setShowBranchPicker] = useState(false);
  const fileInputRef = useRef(null);

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      setCardImage(event.target.result);
      recognizeCard(event.target.result);
    };
    reader.readAsDataURL(file);
  };

  const recognizeCard = (imageData) => {
    setRecognizing(true);
    
    setTimeout(() => {
      const mockCardNumber = '6222021234567890123';
      setCardNumber(mockCardNumber);
      setRecognizing(false);
      setStep(2);
    }, 1500);
  };

  const handleCardNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 19) value = value.slice(0, 19);
    setCardNumber(value);
  };

  const formatCardNumber = (num) => {
    return num.replace(/(\d{4})(?=\d)/g, '$1 ');
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 11) value = value.slice(0, 11);
    setPhone(value);
  };

  const selectedBankInfo = BANKS.find(b => b.id === selectedBank);
  const availableBranches = selectedBank ? BRANCHES[selectedBank] || [] : [];

  const canSubmit = selectedBank && selectedBranch && cardNumber.length >= 16 && phone.length === 11;

  const handleSubmit = () => {
    if (!canSubmit) return;
    
    const cardData = {
      id: editingCard?.id || Date.now(),
      bankName: selectedBankInfo?.name || '',
      bankId: selectedBank,
      cardNumber,
      branch: selectedBranch,
      phone,
      expiryDate: '12/28',
      isDefault: !editingCard
    };
    onSave(cardData);
  };

  return (
    <div className="bg-slate-50 min-h-full pb-24">
      <div className="sticky top-0 bg-white/95 backdrop-blur-sm z-10 px-4 py-3 border-b border-slate-200 flex items-center shadow-sm">
        <button onClick={onBack} className="p-1 -ml-2">
          <ChevronLeft size={24} className="text-slate-700" />
        </button>
        <span className="font-bold text-slate-800 ml-2 text-lg">
          {editingCard ? '编辑银行卡' : '添加银行卡'}
        </span>
      </div>

      <div className="px-4 py-4 space-y-4">
        <div className={`bg-gradient-to-r ${selectedBankInfo?.color || 'from-blue-500 to-blue-600'} rounded-xl p-4 text-white shadow-md transition-all duration-300`}>
          <div className="flex items-center gap-2 mb-1">
            <CreditCard size={16} />
            <span className="text-sm font-medium">
              {step === 1 ? '上传银行卡照片' : '完善银行卡信息'}
            </span>
          </div>
          <div className="font-bold text-xl">
            {step === 1 ? '拍照或上传银行卡正面' : '请核对并补充信息'}
          </div>
        </div>

        {step === 1 && (
          <>
            <div 
              onClick={() => fileInputRef.current?.click()}
              className="bg-white rounded-xl p-6 shadow-sm border-2 border-dashed border-slate-300 hover:border-blue-400 transition-all cursor-pointer"
            >
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleImageUpload}
                className="hidden"
              />
              
              {cardImage ? (
                <div className="relative">
                  <img 
                    src={cardImage} 
                    alt="银行卡" 
                    className="w-full h-48 object-cover rounded-lg"
                  />
                  {recognizing && (
                    <div className="absolute inset-0 bg-black/50 rounded-lg flex items-center justify-center">
                      <div className="text-center text-white">
                        <Loader2 size={32} className="animate-spin mx-auto mb-2" />
                        <span className="text-sm">正在识别卡号...</span>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Camera size={32} className="text-blue-500" />
                  </div>
                  <div className="text-slate-700 font-medium mb-1">点击上传银行卡照片</div>
                  <div className="text-slate-400 text-sm">支持拍照或从相册选择</div>
                </div>
              )}
            </div>

            <div className="bg-blue-50 rounded-xl p-4 border border-blue-200">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center shrink-0">
                  <Camera size={16} className="text-blue-600" />
                </div>
                <div>
                  <div className="text-sm font-medium text-slate-700 mb-1">拍照提示</div>
                  <ul className="text-xs text-slate-500 space-y-1">
                    <li>• 请确保银行卡正面清晰可见</li>
                    <li>• 避免反光、遮挡</li>
                    <li>• 系统将自动识别卡号信息</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="text-center">
              <button
                onClick={() => setStep(2)}
                className="text-blue-600 text-sm font-medium hover:text-blue-700"
              >
                跳过，手动输入卡号 →
              </button>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <div className="bg-white rounded-xl p-4 shadow-sm border border-slate-200 space-y-4">
              <div>
                <label className="block text-sm font-bold text-slate-700 mb-2">银行卡号</label>
                <div className="relative">
                  <input
                    type="text"
                    value={formatCardNumber(cardNumber)}
                    onChange={handleCardNumberChange}
                    placeholder="请输入银行卡号"
                    className="w-full bg-slate-50 border border-slate-200 rounded-lg p-3 pr-12 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all font-mono"
                    maxLength={23}
                  />
                  <CreditCard size={20} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-slate-700 mb-2">开户银行</label>
                <div 
                  onClick={() => setShowBankPicker(true)}
                  className={`w-full bg-slate-50 border rounded-lg p-3 flex items-center justify-between cursor-pointer transition-all ${
                    selectedBank ? 'border-slate-200' : 'border-slate-200 border-dashed'
                  }`}
                >
                  {selectedBankInfo ? (
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 bg-gradient-to-r ${selectedBankInfo.color} rounded-lg flex items-center justify-center text-white font-bold text-sm`}>
                        {selectedBankInfo.name.charAt(0)}
                      </div>
                      <span className="font-medium text-slate-800">{selectedBankInfo.name}</span>
                    </div>
                  ) : (
                    <span className="text-slate-400">请选择开户银行</span>
                  )}
                  <ChevronLeft size={20} className="text-slate-400 rotate-[-90deg]" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-slate-700 mb-2">开户支行</label>
                <div 
                  onClick={() => selectedBank && setShowBranchPicker(true)}
                  className={`w-full bg-slate-50 border rounded-lg p-3 flex items-center justify-between transition-all ${
                    selectedBank ? 'cursor-pointer border-slate-200' : 'cursor-not-allowed border-slate-200 border-dashed opacity-50'
                  }`}
                >
                  {selectedBranch ? (
                    <div className="flex items-center gap-2">
                      <MapPin size={16} className="text-slate-400" />
                      <span className="text-slate-800">{selectedBranch}</span>
                    </div>
                  ) : (
                    <span className="text-slate-400">{selectedBank ? '请选择开户支行' : '请先选择开户银行'}</span>
                  )}
                  <ChevronLeft size={20} className="text-slate-400 rotate-[-90deg]" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-slate-700 mb-2">预留手机号</label>
                <input
                  type="tel"
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="请输入银行预留手机号"
                  className="w-full bg-slate-50 border border-slate-200 rounded-lg p-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  maxLength={11}
                />
              </div>
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
              <div className="flex items-start gap-2">
                <AlertCircle size={16} className="text-amber-500 shrink-0 mt-0.5" />
                <div className="text-xs text-amber-700 leading-relaxed">
                  请确保银行卡信息准确无误。收款账户将用于订单结算，信息错误可能导致收款失败。
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {step === 2 && (
        <div className="fixed bottom-16 left-0 right-0 z-20 flex justify-center pointer-events-none">
          <div className="w-full max-w-md bg-white border-t border-slate-200 p-4 pointer-events-auto">
            <button
              disabled={!canSubmit}
              onClick={handleSubmit}
              className={`w-full py-3.5 rounded-xl font-bold text-white shadow-lg transition-all ${
                canSubmit
                  ? `bg-gradient-to-r ${selectedBankInfo?.color || 'from-blue-500 to-blue-600'} hover:shadow-xl active:scale-[0.98]`
                  : 'bg-slate-300 cursor-not-allowed'
              }`}
            >
              {editingCard ? '保存修改' : '添加银行卡'}
            </button>
          </div>
        </div>
      )}

      {showBankPicker && (
        <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-end justify-center">
          <div className="bg-white rounded-t-3xl w-full max-w-md max-h-[70vh] overflow-hidden shadow-2xl animate-slide-up">
            <div className="sticky top-0 bg-white px-5 py-4 border-b border-slate-200 z-10">
              <div className="flex items-center justify-between">
                <span className="font-bold text-slate-800 text-lg">选择开户银行</span>
                <button
                  onClick={() => setShowBankPicker(false)}
                  className="text-slate-400 hover:text-slate-600"
                >
                  ✕
                </button>
              </div>
            </div>
            <div className="overflow-y-auto p-4 grid grid-cols-3 gap-3" style={{ maxHeight: 'calc(70vh - 60px)' }}>
              {BANKS.map((bank) => (
                <div
                  key={bank.id}
                  onClick={() => {
                    setSelectedBank(bank.id);
                    setSelectedBranch('');
                    setShowBankPicker(false);
                  }}
                  className={`p-3 rounded-xl border-2 cursor-pointer transition-all ${
                    selectedBank === bank.id 
                      ? 'border-blue-500 bg-blue-50' 
                      : 'border-slate-100 hover:border-slate-200'
                  }`}
                >
                  <div className={`w-10 h-10 bg-gradient-to-r ${bank.color} rounded-lg flex items-center justify-center text-white font-bold text-sm mx-auto mb-2`}>
                    {bank.name.charAt(0)}
                  </div>
                  <div className="text-xs text-center text-slate-700 font-medium">{bank.name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {showBranchPicker && (
        <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-end justify-center">
          <div className="bg-white rounded-t-3xl w-full max-w-md max-h-[70vh] overflow-hidden shadow-2xl animate-slide-up">
            <div className="sticky top-0 bg-white px-5 py-4 border-b border-slate-200 z-10">
              <div className="flex items-center justify-between">
                <span className="font-bold text-slate-800 text-lg">选择开户支行</span>
                <button
                  onClick={() => setShowBranchPicker(false)}
                  className="text-slate-400 hover:text-slate-600"
                >
                  ✕
                </button>
              </div>
            </div>
            <div className="overflow-y-auto" style={{ maxHeight: 'calc(70vh - 60px)' }}>
              {availableBranches.map((branch, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedBranch(branch);
                    setShowBranchPicker(false);
                  }}
                  className={`px-5 py-4 border-b border-slate-100 cursor-pointer hover:bg-slate-50 transition-all ${
                    selectedBranch === branch ? 'bg-blue-50' : ''
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <Building2 size={18} className="text-slate-400" />
                    <span className="text-slate-700">{branch}</span>
                    {selectedBranch === branch && (
                      <CheckCircle size={18} className="text-blue-500 ml-auto" />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
